import React, { PureComponent } from 'react';

import { injectIntl, InjectedIntl } from 'react-intl';

import Pagination from '@atlaskit/pagination';
import { uncurlyUuid } from '@atlassian/bitkit-analytics';

import { paginationMessages } from 'src/i18n';
import { publishFact, publishUiEvent } from 'src/utils/analytics/publish';

import { SearchResultsPaginationClickedFact } from '../../facts';

import * as styles from './results-pagination.style';

export type ResultsPaginationProps = {
  currentPage: number;
  onSetPage: (pageNumber: number) => void;
  showPages: boolean;
  pages: number[];
  accountUuid?: string;
};

export default injectIntl(
  class extends PureComponent<
    ResultsPaginationProps & {
      intl: InjectedIntl;
    }
  > {
    handlePageChange = (_e: React.SyntheticEvent, pageNum: number) => {
      this.props.onSetPage(pageNum);
      const fact = new SearchResultsPaginationClickedFact({
        page_num: pageNum,
      });
      publishFact(fact);
      publishUiEvent({
        action: 'clicked',
        actionSubject: 'link',
        actionSubjectId: 'searchResultsPageLink',
        source: 'search',
        containerType: 'account',
        containerId: uncurlyUuid(this.props.accountUuid || ''),
        attributes: {
          page_num: pageNum,
        },
      });
    };

    render() {
      if (!this.props.showPages) {
        return null;
      }

      const { currentPage, intl, pages } = this.props;

      return (
        <styles.ResultsPagination>
          <Pagination
            onChange={this.handlePageChange}
            selectedIndex={currentPage - 1}
            pages={pages}
            nextLabel={intl.formatMessage(paginationMessages.next)}
            previousLabel={intl.formatMessage(paginationMessages.previous)}
          />
        </styles.ResultsPagination>
      );
    }
  }
);
